import { useState, useEffect } from 'react';
import I18n from 'I18n';
const useCollabGenerateActionsPrompt = ({
  initialPrompt,
  isCopilotReady,
  nextAvailableActionId,
  objectTypeId,
  sendActionFromAppToCopilot
}) => {
  const [hasPromptedCopilot, setHasPromptedCopilot] = useState(false);
  useEffect(() => {
    if (hasPromptedCopilot || !isCopilotReady) {
      return;
    }
    setHasPromptedCopilot(true);
    sendActionFromAppToCopilot(!initialPrompt ? copilotActionAskForMoreInfo({
      objectTypeId,
      nextAvailableActionId
    }) : copilotActionWithUserInput({
      objectTypeId,
      nextAvailableActionId,
      initialPrompt
    }));
  }, [hasPromptedCopilot, initialPrompt, isCopilotReady, nextAvailableActionId, objectTypeId, sendActionFromAppToCopilot]);
  return {};
};

// Build a request object for copilot intent with the userInput as the initial prompt.
function copilotActionWithUserInput({
  initialPrompt,
  objectTypeId,
  nextAvailableActionId
}) {
  return {
    title: I18n.text('automation.collabGenActionsFlow.generateActionsPrompt.withInitialPrompt', {
      prompt: initialPrompt
    }),
    data: {
      intent: 'generate_automation_actions',
      objectTypeId,
      startingActionId: nextAvailableActionId,
      userInput: initialPrompt
    }
  };
}

// Build a request object for copilot intent with the promptData to ask the customer for more information.
function copilotActionAskForMoreInfo({
  objectTypeId,
  nextAvailableActionId
}) {
  return {
    title: I18n.text('automation.collabGenActionsFlow.generateActionsPrompt.askForMoreInfo.title'),
    promptData: {
      commandName: 'ask_for_more_options_v1',
      // The path specifies the path in the data object to update with the response from the user in copilot.
      path: ['data', 'userInput'],
      // What to ask the customer when the panel opens.
      promptThread: I18n.text('automation.collabGenActionsFlow.generateActionsPrompt.askForMoreInfo.prompt')
    },
    data: {
      intent: 'generate_automation_actions',
      objectTypeId,
      startingActionId: nextAvailableActionId
      // NOTE: userInput: is filled in by the promptData path when the customer responds to the prompt.
    }
  };
}
export default useCollabGenerateActionsPrompt;